<button mat-icon-button  color="primary" (click)="reloadChecklists()">
  <mat-icon>sync</mat-icon>
</button>
<div class="page-content">
    
    <mat-spinner *ngIf="isLoadingChecklists()"></mat-spinner>
    <mat-accordion multi="true" >
        <mat-expansion-panel *ngFor="let checklist of getFilteredChecklists()" id="noBordersPanel">
          <mat-expansion-panel-header>
            <mat-panel-title class="panel-title">
              {{ checklist.name }}
            </mat-panel-title>
          </mat-expansion-panel-header>
      
          <div>
            
          <div class="p2 flex" *ngIf="progress<100">
            <progress [class]="getBarCss()" max="100" value="{{progress}}"></progress>
            <p style="color: gray;">{{progress}}%</p>
          </div>

          <div class="flex" *ngIf="progress==100">
            Completado 100%
          </div>

          <!-- ITEMS DEL CHECKLIST -->
          <app-requirement-list [requisites]="checklist.items"></app-requirement-list>
          
          <!-- <div id="checklist" *ngFor="let checkItem of checklist.items; let i = index">
            <div class="flex ch-row">
              <input  class="my-checkbox" id="checkItem.id" type="checkbox" (change)="complete(checkItem)" [checked]="checkItem.completed == 1">
              <label class="my-label">{{checkItem.item}}</label>
              <i class="fas fa-chevron-down icon-gray margin-sides-1rem" (click)="clickOn(checkItem)"></i>
            </div>

            <div *ngIf="isVisible(checkItem)">

              <p class="description">{{checkItem.description}}</p>

              <div>
                <p class="description">{{checkItem.completed}}</p>
              </div>
            
              <div>
                <p class="description">{{checkItem.dueDate}}</p>
              </div>
            
              <div>
                <p class="description">{{checkItem.modified}}</p>
              </div>
            </div>
            
          </div> -->

          </div>
        </mat-expansion-panel>
      </mat-accordion>

</div>
